<i class="bi" [class]="icon" (click)="onClick($event)" (keypress)="onClick($event)" tabindex="0"></i>
